import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../../AuthContext';
import { logout } from '../../api';
import ReportButton from '../../components/ReportButton';
import './EnfantLayout.css';

function EnfantLayout() {
  const [collapsed, setCollapsed] = useState(() => {
    return localStorage.getItem('sidebarCollapsed') === 'true';
  });
  const { user, token, clearAuth } = useAuth();
  const navigate = useNavigate();

  const toggleSidebar = () => {
    const newState = !collapsed;
    setCollapsed(newState);
    localStorage.setItem('sidebarCollapsed', newState);
  };

  const handleLogout = async () => {
    try {
      await logout(token);
    } catch (err) {
      // Ignore
    }
    clearAuth();
    navigate('/');
  };

  return (
    <div className={`enfant-layout ${collapsed ? 'sidebar-collapsed' : ''}`}>
      <nav className="enfant-sidebar">
        <div className="sidebar-header">
          <div className="sidebar-logo">
            <img src={collapsed ? '/logo_round.svg' : '/logo.svg'} alt="HAILP" className="sidebar-logo-img" />
          </div>
          <button className="sidebar-toggle" onClick={toggleSidebar} aria-label="Toggle menu">
            <svg viewBox="0 0 24 24" fill="currentColor">
              {collapsed ? (
                <path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/>
              ) : (
                <path d="M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z"/>
              )}
            </svg>
          </button>
        </div>
        <div className="sidebar-menu">
          <NavLink to="/app" end className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"/>
            </svg>
            <span>Accueil</span>
          </NavLink>
          <NavLink to="/app/jeux" className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/>
            </svg>
            <span>Jeux</span>
          </NavLink>
          {user?.team_id && (
            <NavLink to="/app/equipes" className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
              </svg>
              <span>Équipes</span>
            </NavLink>
          )}
          <NavLink to="/app/profil" className={({ isActive }) => isActive ? 'sidebar-item active' : 'sidebar-item'}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
            </svg>
            <span>Profil</span>
          </NavLink>
        </div>
        <div className="sidebar-footer">
          <button className="sidebar-logout" onClick={handleLogout}>
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
            </svg>
            <span>Déconnexion</span>
          </button>
        </div>
      </nav>
      <main className="enfant-main">
        <Outlet />
      </main>
      <ReportButton />
    </div>
  );
}

export default EnfantLayout;
